import React from "react";
import GymNavigation from "../GymNavigation";
import Box from "components/UI/Box";
import Button from "components/UI/Button";
import { API_URL, STRIPE_CLIENT_ID } from "config/constants";
import { toast } from "react-toastify";
import axios from "axios";

import PaymentModal from "./PaymentModal";

class Payments extends React.Component {
  state = {
    PaymentModal: false,
    PaymentModalText: ""
  };
  closePaymentModal = () => {
    this.setState({ PaymentModal: false, PaymentModalText: "" });
  };
  getp = key => {
    if (window.location.search)
      return window.location.search
        .substr(1)
        .split("&")
        .filter(str => str.split("=")[0] === key)[0]
        .split("=")[1];
  };
  pay = () => {
    const { gym_id } = this.props;
    const access_token = localStorage.getItem("access_token");
    const authorization_code = localStorage.getItem("authorization_code");
    const toastId = toast("Paying...");
    let pay_endpoint = `${API_URL}/admin/pay/${gym_id}`;
    if (authorization_code)
      pay_endpoint += `?authorization_code=${authorization_code}`;

    const STRIPE_CALLBACK_URL = `${window.location.origin}/stripe`;
    const STRIPE_URL = `https://connect.stripe.com/express/oauth/authorize?redirect_uri=${STRIPE_CALLBACK_URL}&client_id=${STRIPE_CLIENT_ID}&state=1`;

    axios
      .get(pay_endpoint, {
        headers: {
          "x-access-token": access_token
        }
      })
      .then(res => {
        toast.dismiss(toastId);
        toast(res.data.message, { autoClose: 2500 });
        localStorage.removeItem("authorization_code");
      })
      .catch(err => {
        toast.dismiss(toastId);
        if (err.response) {
          const PaymentModalText = err.response.data.stripe_response
            ? err.response.data.stripe_response
            : err.response.data.error;
          this.setState({ PaymentModalText, PaymentModal: true });

          localStorage.removeItem("authorization_code");
          if (
            err.response.data.error &&
            err.response.data.error.includes(
              "Gym not linked to a stripe account"
            )
          ) {
            window.open(STRIPE_URL);
          }
        }
      });
  };

  render() {
    return (
      <React.Fragment>
        <GymNavigation />

        <div style={style.wrapper}>
          <Box style={style.box} outline>
            <div>
              <img
                src={require("assets/images/dollar-white-blue.png")}
                alt="Dollar Sign"
              />
              <p style={style.label}>Outstanding Amount</p>
              <p style={style.amount}>{`$${this.props.amount}`}</p>
              <Box outline style={style.amountBox}>
                <div style={style.amountRow}>
                  <p style={style.amountData}>Total Amount</p>
                  <p style={style.amountData}>{`$${
                    this.props.totalRevenue
                  }`}</p>
                </div>
                <div style={style.amountRow}>
                  <p style={style.amountData}>FlexIt Revenue</p>
                  <p style={style.amountData}>{`$${
                    this.props.flexitRevenue
                  }`}</p>
                </div>
                {/* <div style={style.amountRow}>
                  <p style={style.amountData}>Gym Revenue</p>
                  <p style={style.amountData}>{`$${this.props.amount}`}</p>
                </div> */}
              </Box>
              <Button type="holo" holo style={style.button} onClick={this.pay}>
                Pay Now
              </Button>
              {this.state.PaymentModal && (
                <PaymentModal
                  close={this.closePaymentModal}
                  text={this.state.PaymentModalText}
                />
              )}
            </div>
          </Box>
        </div>
      </React.Fragment>
    );
  }
}

export default Payments;

const style = {
  wrapper: {
    display: "flex",
    justifyContent: "center",
    marginTop: "10px"
  },
  box: {
    width: "900px",
    padding: "100px 0px"
  },
  button: {
    width: "150px",
    height: "61px",
    fontSize: "16px"
  },
  label: {
    fontSize: "35px",
    color: "#444445",
    margin: "10px 0px"
  },
  amount: {
    fontSize: "45px",
    color: "#00b4d2",
    margin: "10px 0px"
  },
  amountRow: {
    display: "flex",
    justifyContent: "space-between"
  },
  amountBox: {
    width: "300px",
    margin: "auto",
    marginBottom: "10px"
  },
  amountData: {
    color: "#454545",
    margin: "15px 0px"
  }
};
